<template>
  <app-modal
    ref="modal"
    v-bind="$attrs"
    class="modal-container"
    content-class="modal-large"
    title="KCPS向けVNコネクト設定"
  >
    <template v-slot:header="{ cancel }">
      <v-card-title class="screen-title">KCPS向けVNコネクト設定</v-card-title>
      <div class="d-flex flex-row align-start ga-2">
        <template v-if="billingFreeFlg">
          <v-chip size="large" color="info" variant="flat">無料枠</v-chip>
        </template>
        <button
          type="button"
          aria-label="Close"
          class="close ml-5"
          @click="cancel()"
        >
          ×
        </button>
      </div>
    </template>
    <template v-if="isLoaded" v-slot:body="{ cancel }">
      <validation-observer
        :initial-values="{
          routeAggregationAddressList:
            form.cloudVnConnectCommon!.routeAggregationAddressList &&
            form.cloudVnConnectCommon!.routeAggregationAddressList.length > 0
              ? form.cloudVnConnectCommon!.routeAggregationAddressList
              : [''],
          publicRelationSplitRouteList:
            form.cloudVnConnectCommon!.publicRelationSplitRouteList &&
            form.cloudVnConnectCommon!.publicRelationSplitRouteList.length > 0
              ? form.cloudVnConnectCommon!.publicRelationSplitRouteList
              : [],
          publicRelationConnectedExceptList:
            form.cloudVnConnectCommon!.publicRelationConnectedExceptList &&
            form.cloudVnConnectCommon!.publicRelationConnectedExceptList
              .length > 0
              ? form.cloudVnConnectCommon!.publicRelationConnectedExceptList
              : [],
        }"
        v-slot="{ handleSubmit }"
        as="div"
      >
        <v-form novalidate @submit.stop.prevent="handleSubmit(submit)">
          <v-card-text class="pa-0">
            <div class="modal-body">
              <v-container>
                <!-- クラウド設定 -->
                <v-row>
                  <v-col>
                    <h3>クラウド設定</h3>
                  </v-col>
                </v-row>
                <!-- サービスキー -->
                <v-row>
                  <v-col>
                    <app-badge
                      item="KCPSユーザーID"
                      :msg="$filter.message('info_service_key')"
                      :is-info="isAdd"
                      :isRequired="isAdd"
                    />
                    <template v-if="isAdd">
                      <validation-provider
                        name="serviceKey"
                        label="KCPSユーザーID"
                        v-model="
                          (form as CloudVnKcpsPostV2).cloudVnConnectCommon!
                            .serviceKey
                        "
                        :rules="{
                          required: true,
                          is_kcps_no: true,
                        }"
                        v-slot="{ componentField, errorMessage, meta }"
                      >
                        <app-form-input
                          v-bind="componentField"
                          :field-meta="meta"
                          :error-messages="errorMessage"
                        />
                      </validation-provider>
                    </template>
                    <app-form-input
                      v-else
                      :value="
                        cloudVnKcpsDetail!.cloudVnConnectCommon.serviceKey
                      "
                      disabled
                    />
                  </v-col>
                </v-row>
                <!--ロケーション-->
                <v-row>
                  <v-col>
                    <app-badge
                      item="ロケーション"
                      :is-info="false"
                      :isRequired="isAdd"
                    />
                    <template v-if="isAdd">
                      <validation-provider
                        name="location"
                        label="ロケーション"
                        v-model="
                          (form as CloudVnKcpsPostV2).cloudVnConnectCommon!
                            .location
                        "
                        :rules="{ required: true }"
                        v-slot="{ componentField, errorMessage, meta }"
                      >
                        <app-select
                          :items="locationOptions"
                          item-title="text"
                          item-value="value"
                          v-bind="componentField"
                          :field-meta="meta"
                          :error-messages="errorMessage"
                        />
                      </validation-provider>
                    </template>
                    <app-form-input
                      v-else
                      :value="
                        $filter.enumTo(
                          cloudVnKcpsDetail!.cloudVnConnectCommon.location,
                          'kcpsLocationV2'
                        )
                      "
                      disabled
                    />
                  </v-col>
                </v-row>
                <!-- 契約番号(M番号) -->
                <v-row>
                  <v-col>
                    <app-badge
                      item="契約番号(M番号)"
                      :msg="$filter.message('info_m_number')"
                      :is-info="isAdd"
                      :isRequired="isAdd"
                    />
                    <template v-if="isAdd">
                      <validation-provider
                        name="mNumber"
                        label="契約番号(M番号)"
                        v-model="
                          (form as CloudVnKcpsPostV2).cloudVnConnectCommon!
                            .mNumber
                        "
                        :rules="{
                          required: true,
                          is_m_number: true,
                        }"
                        v-slot="{ componentField, errorMessage, meta }"
                      >
                        <app-form-input
                          v-bind="componentField"
                          :field-meta="meta"
                          :error-messages="errorMessage"
                        />
                      </validation-provider>
                    </template>
                    <app-form-input
                      v-else
                      :value="cloudVnKcpsDetail!.cloudVnConnectCommon.mNumber"
                      disabled
                    />
                  </v-col>
                </v-row>
                <!-- 利用ゾーン -->
                <v-row>
                  <v-col>
                    <app-badge
                      item="利用ゾーン"
                      :msg="$filter.message('info_usage_zone')"
                      :maxWidth="'1000'"
                      :is-info="isAdd"
                      :isRequired="isAdd"
                    />
                    <template v-if="isAdd">
                      <validation-provider
                        name="usageZone"
                        label="利用ゾーン"
                        v-model="
                          (form as CloudVnKcpsPostV2).cloudVnConnectCommon!
                            .usageZone
                        "
                        :rules="{
                          required: true,
                          is_usage_zone_location: {
                            prefix: locationPrefix,
                          },
                        }"
                        v-slot="{ componentField, errorMessage, meta }"
                      >
                        <app-form-input
                          v-bind="componentField"
                          :field-meta="meta"
                          :error-messages="errorMessage"
                        />
                      </validation-provider>
                    </template>
                    <app-form-input
                      v-else
                      :value="cloudVnKcpsDetail!.cloudVnConnectCommon.usageZone"
                      disabled
                    />
                  </v-col>
                </v-row>
                <!--接続先仮想ネットワーク(VPN/VN)名-->
                <v-row>
                  <v-col>
                    <app-badge
                      item="接続先仮想ネットワーク(VPN/VN)名"
                      :is-info="false"
                      :isRequired="isAdd"
                    />
                    <template v-if="isAdd">
                      <validation-provider
                        name="selectedVpnVn"
                        label="接続先仮想ネットワーク(VPN/VN)名"
                        v-model="selectedVpnVn"
                        :rules="{ required: true }"
                        v-slot="{ componentField, errorMessage, meta }"
                      >
                        <app-select-search
                          :items="vpnVnCodeSelectList"
                          item-title="text"
                          item-value="value"
                          v-bind="componentField"
                          :field-meta="meta"
                          :error-messages="errorMessage"
                        />
                      </validation-provider>
                    </template>
                    <!--変更の場合、変更不可-->
                    <app-form-input v-else :value="vpnVnName" disabled />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <app-badge
                      item="プライベートLAN ID"
                      :msg="$filter.message('info_private_lan_id')"
                      :is-info="isAdd"
                      :isRequired="isAdd"
                    />
                    <template v-if="isAdd">
                      <validation-provider
                        name="privateLanId"
                        label="プライベートLAN ID"
                        v-model="
                          (form as CloudVnKcpsPostV2).cloudVnConnectCommon!
                            .privateLanId
                        "
                        :rules="{
                          required: true,
                          is_network_id: true,
                        }"
                        v-slot="{ componentField, errorMessage, meta }"
                      >
                        <app-form-input
                          v-bind="componentField"
                          :field-meta="meta"
                          :error-messages="errorMessage"
                          :placeholder="
                            $filter.message('placeholder_private_lan_id')
                          "
                        />
                      </validation-provider>
                    </template>
                    <app-form-input
                      v-else
                      :value="
                        cloudVnKcpsDetail!.cloudVnConnectCommon.privateLanId
                      "
                      disabled
                    />
                  </v-col>
                </v-row>
                <!-- 仮想IPアドレス -->
                <v-row>
                  <v-col>
                    <app-badge
                      item="仮想IPアドレス"
                      :msg="$filter.message('info_virtual_ip_address')"
                      :is-info="isAdd"
                      :isRequired="isAdd"
                    />
                    <template v-if="isAdd">
                      <validation-provider
                        name="virtualIpAddress"
                        label="仮想IPアドレス"
                        v-model="
                          (form as CloudVnKcpsPostV2).cloudVnConnectCommon!
                            .virtualIpAddress
                        "
                        :rules="{
                          required: true,
                          is_ipv4: true,
                          is_not_loopback_ip: true,
                          is_not_multicast_ip: true,
                          is_not_class_e_ip: true,
                          is_not_broadcast_ip: true,
                          is_not_current_ip: true,
                        }"
                        v-slot="{ componentField, errorMessage, meta }"
                      >
                        <app-form-input
                          :placeholder="
                            $filter.message('placeholder_virtual_ip_address')
                          "
                          v-bind="componentField"
                          :field-meta="meta"
                          :error-messages="errorMessage"
                        />
                      </validation-provider>
                    </template>
                    <app-form-input
                      v-else
                      :value="
                        cloudVnKcpsDetail!.cloudVnConnectCommon.virtualIpAddress
                      "
                      disabled
                    />
                  </v-col>
                </v-row>

                <!-- VNコネクト設定 -->
                <v-row>
                  <v-col>
                    <h3>VNコネクト設定</h3>
                  </v-col>
                </v-row>
                <!--品目-->
                <v-row>
                  <v-col>
                    <app-badge
                      item="品目"
                      :is-info="false"
                      :isRequired="true"
                    />
                    <validation-provider
                      name="bandwidth"
                      label="品目"
                      v-model="form.cloudVnConnectCommon!.bandwidth"
                      :rules="{
                        required: true,
                      }"
                      v-slot="{ componentField, errorMessage, meta }"
                    >
                      <app-select
                        :items="bandwidthSelectList"
                        item-title="text"
                        item-value="value"
                        v-bind="componentField"
                        :field-meta="meta"
                        :error-messages="errorMessage"
                      />
                    </validation-provider>
                  </v-col>
                </v-row>
                <!--VNコネクト名(Act)-->
                <v-row>
                  <v-col>
                    <app-badge
                      item="VNコネクト名(Act)"
                      :msg="
                        $filter.message('info_max_length', {
                          maxLength: '20',
                        })
                      "
                      :is-info="true"
                      :isRequired="true"
                    />
                    <validation-provider
                      name="vnConnectNameAct"
                      label="VNコネクト名(Act)"
                      v-model="form.cloudVnConnectAct!.vnConnectName"
                      :rules="{
                        required: true,
                        max: { length: 20 },
                        alpha_num_zenkaku: true,
                      }"
                      v-slot="{ componentField, errorMessage, meta }"
                    >
                      <app-form-input
                        v-bind="componentField"
                        :field-meta="meta"
                        :error-messages="errorMessage"
                      />
                    </validation-provider>
                  </v-col>
                </v-row>
                <!--VNコネクト名(Sby)-->
                <v-row>
                  <v-col>
                    <app-badge
                      item="VNコネクト名(Sby)"
                      :msg="
                        $filter.message('info_max_length', {
                          maxLength: '20',
                        })
                      "
                      :is-info="true"
                      :isRequired="true"
                    />
                    <validation-provider
                      name="vnConnectNameSby"
                      label="VNコネクト名(Sby)"
                      v-model="form.cloudVnConnectSby!.vnConnectName"
                      :rules="{
                        required: true,
                        max: { length: 20 },
                        alpha_num_zenkaku: true,
                      }"
                      v-slot="{ componentField, errorMessage, meta }"
                    >
                      <app-form-input
                        v-bind="componentField"
                        :field-meta="meta"
                        :error-messages="errorMessage"
                      />
                    </validation-provider>
                  </v-col>
                </v-row>

                <!-- ルーティング情報(共通) -->
                <v-row>
                  <v-col>
                    <h3>ルーティング情報(共通)</h3>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <app-label-group label="ルーティング種別" value="BGP4" />
                  </v-col>
                </v-row>
                <!--AS番号-->
                <v-row>
                  <v-col>
                    <app-badge
                      item="AS番号"
                      :msg="
                        $filter.message(`info_as_number`, {
                          numberArray: `64512〜65534`,
                        })
                      "
                      :is-info="isAdd"
                      :is-required="isAdd"
                    />
                    <validation-provider
                      name="asNumber"
                      label="AS番号"
                      v-model.number="
                        (form as CloudVnKcpsPostV2).cloudVnConnectCommon!
                          .asNumber
                      "
                      :rules="{
                        required: true,
                        numeric: true,
                        is_number_range: {
                          range: '64512-65534',
                        },
                      }"
                      v-slot="{ componentField, errorMessage, meta }"
                    >
                      <app-form-input-number
                        v-bind="componentField"
                        :disabled="!isAdd"
                        :field-meta="meta"
                        :error-messages="errorMessage"
                      />
                    </validation-provider>
                  </v-col>
                </v-row>
                <!--Maximum Prefix(Act)-->
                <v-row>
                  <v-col>
                    <app-badge
                      item="Maximum Prefix"
                      :is-info="false"
                      :isRequired="true"
                    />
                    <validation-provider
                      name="maximumPrefix"
                      label="Maximum Prefix(Act)"
                      v-model="form.cloudVnConnectCommon!.maximumPrefix"
                      :rules="{ required: true }"
                      v-slot="{ componentField, errorMessage, meta }"
                    >
                      <app-select
                        :items="maximumPrefixSelectList"
                        item-title="text"
                        item-value="value"
                        v-bind="componentField"
                        :field-meta="meta"
                        :error-messages="errorMessage"
                      />
                    </validation-provider>
                  </v-col>
                </v-row>

                <!--Connectedルート広報-->
                <v-row>
                  <v-col>
                    <app-badge
                      item="Connectedルート広報"
                      :msg="$filter.message('info_public_relation')"
                    />
                    <v-radio-group
                      v-model="form.cloudVnConnectCommon!.publicRelation"
                      hide-details
                      inline
                    >
                      <v-radio label="有効" :value="true" />
                      <v-radio label="無効" :value="false" />
                    </v-radio-group>
                  </v-col>
                </v-row>
                <!--BGP 広報ルート(ルート分割)-->
                <v-row class="mt-6">
                  <v-col>
                    <app-badge
                      item="BGP 広報ルート(ルート分割)"
                      :msg="$filter.message('info_public_relation_split_route')"
                      :isRequired="publicRelationSplitRouteItems.length > 0"
                    />
                    <validation-array
                      name="publicRelationSplitRouteList"
                      v-slot="{ fields, push, remove }"
                    >
                      <template v-for="(item, index) in fields" :key="item.key">
                        <v-row class="ga-2">
                          <validation-provider
                            :name="'splitRoute_' + item.key"
                            label="BGP 広報ルート(ルート分割)"
                            v-model="
                              form.cloudVnConnectCommon!
                                .publicRelationSplitRouteList![index]
                            "
                            :rules="{
                              required: true,
                              is_ip_subnet: { min: 1, max: 32 },
                              is_network_address: true,
                              is_not_default_root: true,
                              is_not_loopback_ip: true,
                              is_not_multicast_ip: true,
                              is_not_class_e_ip: true,
                              is_not_broadcast_ip: true,
                              duplicate: {
                                list: splitRouteListExcluding(index),
                              },
                            }"
                            v-slot="{ componentField, errorMessage, meta }"
                          >
                            <app-form-input
                              class="ml-1"
                              v-bind="componentField"
                              :field-meta="meta"
                              :error-messages="errorMessage"
                              :placeholder="
                                $filter.message(
                                  'placeholder_public_relation_split_route'
                                )
                              "
                            />
                            <v-btn
                              icon="$mdiMinus"
                              size="small"
                              variant="outlined"
                              class="rounded-sm ml-2 mr-3"
                              @click="removeSplitRoute(index, remove)"
                            />
                          </validation-provider>
                        </v-row>
                      </template>
                      <v-row justify="end">
                        <v-btn
                          icon="$mdiPlus"
                          size="small"
                          variant="outlined"
                          class="rounded-sm ml-2 mr-3"
                          :disabled="publicRelationSplitRouteItems.length >= 10"
                          @click="addSplitRoute(push)"
                        />
                      </v-row>
                    </validation-array>
                  </v-col>
                </v-row>
                <!--BGP 広報ルート(Connected以外)-->
                <v-row class="mt-6">
                  <v-col cols="12">
                    <app-label-group label="BGP 広報ルート(Connected以外)" />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="5" class="address-title">
                    <app-badge
                      item="LANアドレス"
                      :isRequired="
                        publicRelationConnectedExceptItems.length > 0
                      "
                      :msg="
                        $filter.message('info_public_relation_connected_except')
                      "
                    />
                  </v-col>
                  <v-col cols="7" class="pl-10 address-title">
                    <app-badge
                      item="ネクストホップアドレス"
                      :isRequired="
                        publicRelationConnectedExceptItems.length > 0
                      "
                      :msg="$filter.message('info_public_relation_next_hop')"
                    />
                  </v-col>
                </v-row>
                <validation-array
                  name="publicRelationConnectedExceptList"
                  v-slot="{ fields, push, remove }"
                >
                  <template v-for="(item, index) in fields" :key="item.key">
                    <v-row class="ga-2">
                      <v-col class="py-0">
                        <validation-provider
                          :name="'connectedExcept_' + item.key"
                          label="LANアドレス"
                          v-model="
                            form.cloudVnConnectCommon!
                              .publicRelationConnectedExceptList![index]
                          "
                          :rules="{
                            required: true,
                            is_ip_subnet: { min: 1, max: 32 },
                            is_network_address: true,
                            is_not_default_root: true,
                            is_not_loopback_ip: true,
                            is_not_multicast_ip: true,
                            is_not_class_e_ip: true,
                            is_not_broadcast_ip: true,
                            duplicate: {
                              list: connectedExceptListExcluding(index),
                            },
                          }"
                          v-slot="{ componentField, errorMessage, meta }"
                        >
                          <app-form-input
                            v-bind="componentField"
                            :field-meta="meta"
                            :error-messages="errorMessage"
                            :placeholder="
                              $filter.message(
                                'placeholder_public_relation_connected_except'
                              )
                            "
                          />
                        </validation-provider>
                      </v-col>
                      <v-col class="py-0">
                        <validation-provider
                          :name="'nextHop_' + item.key"
                          label="ネクストホップアドレス"
                          v-model="
                            form.cloudVnConnectCommon!
                              .publicRelationNextHopList![index]
                          "
                          :rules="{
                            required: true,
                            is_ipv4: true,
                            is_not_loopback_ip: true,
                            is_not_multicast_ip: true,
                            is_not_class_e_ip: true,
                            is_not_broadcast_ip: {
                              range: (form as CloudVnKcpsPostV2)
                                .cloudVnConnectCommon!
                                .publicRelationConnectedExceptList![index],
                            },
                            is_not_current_ip: true,
                            is_not_network_ip: {
                              range: (form as CloudVnKcpsPostV2)
                                .cloudVnConnectCommon!
                                .publicRelationConnectedExceptList![index],
                            },
                          }"
                          v-slot="{ componentField, errorMessage, meta }"
                        >
                          <app-form-input
                            v-bind="componentField"
                            :field-meta="meta"
                            :error-messages="errorMessage"
                            :placeholder="
                              $filter.message(
                                'placeholder_public_relation_next_hop'
                              )
                            "
                          />
                        </validation-provider>
                      </v-col>
                      <v-btn
                        icon="$mdiMinus"
                        size="small"
                        variant="outlined"
                        class="rounded-sm ml-2 mr-3"
                        @click="removeConnectedExcept(index, remove)"
                      />
                    </v-row>
                  </template>
                  <v-row justify="end">
                    <v-btn
                      icon="$mdiPlus"
                      size="small"
                      variant="outlined"
                      class="rounded-sm ml-2 mr-3"
                      :disabled="
                        publicRelationConnectedExceptItems.length >= 100
                      "
                      @click="addConnectedExcept(push)"
                    />
                  </v-row>
                </validation-array>

                <!-- ルーティング情報(Act) -->
                <v-row>
                  <v-col>
                    <h3>ルーティング情報(Act)</h3>
                  </v-col>
                </v-row>
                <!--WANアドレス(Act)-->
                <v-row>
                  <v-col>
                    <app-badge
                      item="WANアドレス"
                      :msg="
                        '・' +
                        $filter.message('info_cidr_ip_v4_with_subnet_2', {
                          subnet: '30',
                        }) +
                        '\n' +
                        '・' +
                        $filter.message('info_cidr_subnet', {
                          subnet: '30',
                        })
                      "
                      :is-info="isAdd"
                      :is-required="isAdd"
                    />
                    <validation-provider
                      name="wanAddressAct"
                      label="WANアドレス(Act)"
                      v-model="
                        (form as CloudVnKcpsPostV2).cloudVnConnectAct!
                          .wanAddress
                      "
                      :rules="{
                        required: true,
                        is_ip_subnet: { eq: 30 },
                        is_not_current_ip: true,
                        is_not_loopback_ip: true,
                        is_not_multicast_ip: true,
                        is_not_class_e_ip: true,
                        is_not_broadcast_ip: true,
                        is_not_network_ip: true,
                      }"
                      v-slot="{ componentField, errorMessage, meta }"
                    >
                      <app-form-input
                        :disabled="!isAdd"
                        :placeholder="
                          !isAdd
                            ? null
                            : $filter.message(
                                'placeholder_ip_address_with_subnet30'
                              )
                        "
                        v-bind="componentField"
                        :field-meta="meta"
                        :error-messages="errorMessage"
                      />
                    </validation-provider>
                  </v-col>
                </v-row>
                <!--ピアIPアドレス(Act)-->
                <v-row>
                  <v-col>
                    <app-badge
                      item="ピアIPアドレス"
                      :msg="
                        $filter.message('info_ip_address_v4_2', { host: '2' })
                      "
                      :is-info="isAdd"
                      :is-required="isAdd"
                    />
                    <validation-provider
                      name="peerIpAddressAct"
                      label="ピアIPアドレス(Act)"
                      v-model="
                        (form as CloudVnKcpsPostV2).cloudVnConnectAct!
                          .peerIpAddress
                      "
                      :rules="{
                        required: true,
                        is_ipv4: true,
                        cross_wan_address_within_range: {
                          wan: (form as CloudVnKcpsPostV2).cloudVnConnectAct!
                            .wanAddress,
                        },
                        cross_wan_peer_consecutive: {
                          wan: (form as CloudVnKcpsPostV2).cloudVnConnectAct!
                            .wanAddress,
                        },
                        is_not_loopback_ip: true,
                        is_not_multicast_ip: true,
                        is_not_class_e_ip: true,
                        is_not_broadcast_ip: {
                          range: (form as CloudVnKcpsPostV2).cloudVnConnectAct!
                            .wanAddress,
                        },
                        is_not_network_ip: {
                          range: (form as CloudVnKcpsPostV2).cloudVnConnectAct!
                            .wanAddress,
                        },
                      }"
                      v-slot="{ componentField, errorMessage, meta }"
                    >
                      <app-form-input
                        :disabled="!isAdd"
                        :placeholder="
                          !isAdd
                            ? null
                            : $filter.message('placeholder_ip_address_3', {
                                host: '2',
                              })
                        "
                        v-bind="componentField"
                        :field-meta="meta"
                        :error-messages="errorMessage"
                      />
                    </validation-provider>
                  </v-col>
                </v-row>
                <!--プライベートIPアドレス(Act)-->
                <v-row>
                  <v-col>
                    <app-badge
                      item="プライベートIPアドレス"
                      :msg="$filter.message('info_private_ip_address')"
                      :is-info="isAdd"
                      :isRequired="isAdd"
                    />
                    <validation-provider
                      name="privateIpAddressAct"
                      label="プライベートIPアドレス(Act)"
                      v-model="
                        (form as CloudVnKcpsPostV2).cloudVnConnectAct!
                          .privateIpAddress
                      "
                      :rules="{
                        required: true,
                        is_ipv4: true,
                      }"
                      v-slot="{ componentField, errorMessage, meta }"
                    >
                      <app-form-input
                        :disabled="!isAdd"
                        :placeholder="
                          $filter.message('placeholder_private_ip_address_act')
                        "
                        v-bind="componentField"
                        :field-meta="meta"
                        :error-messages="errorMessage"
                      />
                    </validation-provider>
                  </v-col>
                </v-row>
                <!--Local Preference(Act)-->
                <v-row>
                  <v-col>
                    <app-label-group label="Local Preference">
                      <template #value>
                        <app-form-input
                          :value="
                            $filter.enumTo('HIGH_PRIORITY', 'localPreference')
                          "
                          disabled
                        />
                      </template>
                    </app-label-group>
                  </v-col>
                </v-row>
                <!--MED(Act)-->
                <v-row>
                  <v-col>
                    <app-label-group label="MED">
                      <template #value>
                        <app-form-input
                          :value="$filter.enumTo('LOW_PRIORITY', 'med')"
                          disabled
                        />
                      </template>
                    </app-label-group>
                  </v-col>
                </v-row>

                <!-- ルーティング情報(Sby) -->
                <v-row>
                  <v-col>
                    <h3>ルーティング情報(Sby)</h3>
                  </v-col>
                </v-row>
                <!--WANアドレス(Sby)-->
                <v-row>
                  <v-col>
                    <app-badge
                      item="WANアドレス"
                      :msg="
                        '・' +
                        $filter.message('info_cidr_ip_v4_with_subnet_2', {
                          subnet: '30',
                        }) +
                        '\n' +
                        '・' +
                        $filter.message('info_cidr_subnet', {
                          subnet: '30',
                        })
                      "
                      :is-info="isAdd"
                      :isRequired="isAdd"
                    />
                    <validation-provider
                      name="wanAddressSby"
                      label="WANアドレス(Sby)"
                      v-model="
                        (form as CloudVnKcpsPostV2).cloudVnConnectSby!
                          .wanAddress
                      "
                      :rules="{
                        required: true,
                        is_ip_subnet: { eq: 30 },
                        is_not_current_ip: true,
                        is_not_loopback_ip: true,
                        is_not_multicast_ip: true,
                        is_not_class_e_ip: true,
                        is_not_broadcast_ip: true,
                        is_not_network_ip: true,
                      }"
                      v-slot="{ componentField, errorMessage, meta }"
                    >
                      <app-form-input
                        :disabled="!isAdd"
                        :placeholder="
                          !isAdd
                            ? null
                            : $filter.message(
                                'placeholder_ip_address_with_subnet30'
                              )
                        "
                        v-bind="componentField"
                        :field-meta="meta"
                        :error-messages="errorMessage"
                      />
                    </validation-provider>
                  </v-col>
                </v-row>
                <!--ピアIPアドレス(Sby)-->
                <v-row>
                  <v-col>
                    <app-badge
                      item="ピアIPアドレス"
                      :msg="
                        $filter.message('info_ip_address_v4_2', { host: '2' })
                      "
                      :is-info="isAdd"
                      :isRequired="isAdd"
                    />
                    <validation-provider
                      name="peerIpAddressSby"
                      label="ピアIPアドレス(Sby)"
                      v-model="
                        (form as CloudVnKcpsPostV2).cloudVnConnectSby!
                          .peerIpAddress
                      "
                      :rules="{
                        required: true,
                        is_ipv4: true,
                        cross_wan_address_within_range: {
                          wan: (form as CloudVnKcpsPostV2).cloudVnConnectSby!
                            .wanAddress,
                        },
                        cross_wan_peer_consecutive: {
                          wan: (form as CloudVnKcpsPostV2).cloudVnConnectSby!
                            .wanAddress,
                        },
                        is_not_loopback_ip: true,
                        is_not_multicast_ip: true,
                        is_not_class_e_ip: true,
                        is_not_broadcast_ip: {
                          range: (form as CloudVnKcpsPostV2).cloudVnConnectSby!
                            .wanAddress,
                        },
                        is_not_network_ip: {
                          range: (form as CloudVnKcpsPostV2).cloudVnConnectSby!
                            .wanAddress,
                        },
                      }"
                      v-slot="{ componentField, errorMessage, meta }"
                    >
                      <app-form-input
                        :disabled="!isAdd"
                        :placeholder="
                          !isAdd
                            ? null
                            : $filter.message('placeholder_ip_address_3', {
                                host: '2',
                              })
                        "
                        v-bind="componentField"
                        :field-meta="meta"
                        :error-messages="errorMessage"
                      />
                    </validation-provider>
                  </v-col>
                </v-row>
                <!--プライベートIPアドレス(Sby)-->
                <v-row>
                  <v-col>
                    <app-badge
                      item="プライベートIPアドレス"
                      :msg="$filter.message('info_private_ip_address')"
                      :is-info="isAdd"
                      :isRequired="isAdd"
                    />
                    <validation-provider
                      name="privateIpAddressSby"
                      label="プライベートIPアドレス(Sby)"
                      v-model="
                        (form as CloudVnKcpsPostV2).cloudVnConnectSby!
                          .privateIpAddress
                      "
                      :rules="{
                        required: true,
                        is_ipv4: true,
                      }"
                      v-slot="{ componentField, errorMessage, meta }"
                    >
                      <app-form-input
                        :disabled="!isAdd"
                        :placeholder="
                          $filter.message('placeholder_private_ip_address_sby')
                        "
                        v-bind="componentField"
                        :field-meta="meta"
                        :error-messages="errorMessage"
                      />
                    </validation-provider>
                  </v-col>
                </v-row>
                <!--Local Preference(Sby)-->
                <v-row>
                  <v-col>
                    <app-label-group label="Local Preference">
                      <template #value>
                        <app-form-input
                          :value="
                            $filter.enumTo('LOW_PRIORITY', 'localPreference')
                          "
                          disabled
                        />
                      </template>
                    </app-label-group>
                  </v-col>
                </v-row>
                <!--MED(Sby)-->
                <v-row>
                  <v-col>
                    <app-label-group label="MED">
                      <template #value>
                        <app-form-input
                          :value="$filter.enumTo('HIGH_PRIORITY', 'med')"
                          disabled
                        />
                      </template>
                    </app-label-group>
                  </v-col>
                </v-row>

                <!-- カスタム経路集約情報 -->
                <v-row>
                  <v-col>
                    <h3>カスタム経路集約情報</h3>
                  </v-col>
                </v-row>
                <!--経路集約-->
                <v-row>
                  <v-col>
                    <app-badge
                      item="経路集約"
                      :isRequired="false"
                      :isInfo="false"
                    />
                    <v-radio-group
                      v-model="form.cloudVnConnectCommon!.routeAggregation"
                      hide-details
                      inline
                    >
                      <v-radio
                        v-for="(routeOption, index) in routeOptions"
                        :key="`${routeOption.text + index}`"
                        :label="routeOption.text"
                        :value="routeOption.value"
                      />
                    </v-radio-group>
                  </v-col>
                </v-row>
                <!--経路集約アドレス-->
                <v-row
                  v-if="form.cloudVnConnectCommon!.routeAggregation !== 'OFF'"
                >
                  <v-col>
                    <app-badge
                      item="経路集約アドレス"
                      :is-required="
                        form.cloudVnConnectCommon!.routeAggregation === 'CUSTOM'
                      "
                      :is-info="
                        form.cloudVnConnectCommon!.routeAggregation === 'CUSTOM'
                      "
                      :msg="$filter.message('info_routing_address')"
                    />
                    <template
                      v-if="
                        form.cloudVnConnectCommon!.routeAggregation === 'ON'
                      "
                    >
                      <span class="ml-3">0.0.0.0/0</span>
                    </template>
                    <template
                      v-if="
                        form.cloudVnConnectCommon!.routeAggregation === 'CUSTOM'
                      "
                    >
                      <validation-array
                        name="routeAggregationAddressList"
                        v-slot="{ fields, push, remove }"
                      >
                        <template
                          v-for="(item, index) in fields"
                          :key="item.key"
                        >
                          <v-row class="ga-2">
                            <validation-provider
                              :name="`routingIp_${item.key}`"
                              label="経路集約アドレス"
                              v-model="
                                form.cloudVnConnectCommon!
                                  .routeAggregationAddressList![index]
                              "
                              :rules="{
                                required: true,
                                is_ip_subnet: { min: 1, max: 30 },
                                is_network_address: true,
                                is_not_default_root: true,
                                duplicate: { list: routingAddressList(index) },
                              }"
                              v-slot="{ componentField, errorMessage, meta }"
                            >
                              <app-form-input
                                class="ml-1"
                                :placeholder="
                                  $filter.message(
                                    'placeholder_ip_address_with_subnet24'
                                  )
                                "
                                v-bind="componentField"
                                :field-meta="meta"
                                :error-messages="errorMessage"
                              />
                              <v-btn
                                icon="$mdiMinus"
                                size="small"
                                variant="outlined"
                                class="rounded-sm ml-2 mr-3"
                                @click="removeRouteAddress(index, remove)"
                              />
                            </validation-provider>
                          </v-row>
                        </template>
                        <!--経路集約アドレス追加-CUSTOMのみ表示-->
                        <v-row justify="end">
                          <v-btn
                            icon="$mdiPlus"
                            size="small"
                            variant="outlined"
                            class="rounded-sm ml-2 mr-3"
                            :disabled="currentLength >= 100"
                            @click="addRouteAddress(push)"
                          />
                        </v-row>
                      </validation-array>
                    </template>
                  </v-col>
                </v-row>

                <!--備考-->
                <v-row>
                  <v-col>
                    <app-badge
                      item="備考"
                      :msg="
                        $filter.message('info_max_length', { maxLength: '20' })
                      "
                      :is-info="true"
                      :isRequired="false"
                    />
                    <validation-provider
                      name="description"
                      label="備考"
                      v-model="form.cloudVnConnectCommon!.description"
                      :rules="{ max: { length: 20 } }"
                      v-slot="{ componentField, errorMessage, meta }"
                    >
                      <app-form-input
                        v-bind="componentField"
                        :field-meta="meta"
                        :error-messages="errorMessage"
                      />
                    </validation-provider>
                  </v-col>
                </v-row>
              </v-container>
            </div>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-list-item class="w-100 pa-1">
              <template v-slot:append>
                <v-btn type="submit" color="primary" variant="flat">{{
                  isAdd ? "追加" : "変更"
                }}</v-btn>
                <v-btn color="primary" variant="outlined" @click="cancel"
                  >キャンセル
                </v-btn>
              </template>
            </v-list-item>
          </v-card-actions>
        </v-form>
      </validation-observer>
    </template>
  </app-modal>
</template>

<script lang="ts">
import type { PropType } from "vue";
import { defineComponent } from "vue";
import { VueFinalModal } from "vue-final-modal";
import type {
  BandWidth,
  RouteAggregation,
  VpnVnCode as CloudVpnVnCode,
} from "@/apis/CloudVnMsApi";
import type { CloudLine } from "@/apis/CloudLineApi";
import cloneDeep from "lodash/cloneDeep";
import type {
  CloudVnKcpsDetailV2,
  CloudVnKcpsPostV2,
  CloudVnKcpsPutV2,
} from "@/apis/CloudVnKcpsApi";
import type { VpnVnCode } from "@/apis/InformationApi";
import MultiCloudKcps3VnConnectionEditConfirm from "@/modals/multicloud/kcps3/v2/V2MultiCloudKcps3VnConnectionEditConfirm.vue";
import type { UpperLimitEntity } from "@/apis/UpperLimitApi";
import sortCompare from "@/services/SortService";

export default defineComponent({
  name: "MultiCloudKcps3VnLineEdit",
  props: {
    /** クラウド回線SEQ */
    cloudLineSeq: {
      type: String as PropType<string>,
      required: true,
    },
    // 変更の場合用
    cloudVnKcpsDetail: {
      type: Object as PropType<CloudVnKcpsDetailV2>,
      required: false,
      default: undefined,
    },
    // 追加の場合用
    cloudVnKcpsKeyId: {
      type: String as PropType<string>,
      required: false,
      default: undefined,
    },
    billingFreeFlg: {
      type: Boolean as PropType<boolean>,
      required: false,
      default: false,
    },
    // クラウド回線の帯域最大値(品目の上限値制御用)
    cloudLineMaxBandwidth: {
      type: Object as PropType<CloudLine["bandwidth"]>,
      required: true,
    },
    remainingBandwidth: {
      type: Number as PropType<number>,
      required: true,
    },
  },
  data() {
    // 新規/更新のformデータを作成
    const form: CloudVnKcpsPostV2 | CloudVnKcpsPutV2 = (() => {
      if (this.cloudVnKcpsDetail) {
        // 変更
        const cloudVnKcpsDetailCopy = cloneDeep(this.cloudVnKcpsDetail);
        const common = cloudVnKcpsDetailCopy.cloudVnConnectCommon;
        if (common) {
          // 経路集約アドレスを数値昇順でソート
          if (Array.isArray(common.routeAggregationAddressList)) {
            common.routeAggregationAddressList =
              common.routeAggregationAddressList.sortIpAddress();
          }
          // BGP 広報ルート(ルート分割)を数値昇順でソート
          if (Array.isArray(common.publicRelationSplitRouteList)) {
            common.publicRelationSplitRouteList =
              common.publicRelationSplitRouteList.sortIpAddress();
          }
          // BGP 広報ルート(Connected以外)をLANアドレスで数値昇順ソートし、ネクストホップも同順に並べ替え
          if (
            Array.isArray(common.publicRelationConnectedExceptList) &&
            Array.isArray(common.publicRelationNextHopList)
          ) {
            const pairs = common.publicRelationConnectedExceptList
              .map((lan, i) => ({
                lan,
                nextHop: common.publicRelationNextHopList![i] ?? "",
              }))
              .sort((a, b) => sortCompare(a, b, [["lan", "asc"]]));
            common.publicRelationConnectedExceptList = pairs.map((p) => p.lan);
            common.publicRelationNextHopList = pairs.map((p) => p.nextHop);
          }
        }
        const form: CloudVnKcpsPutV2 = {
          cloudVnConnectCommon: {
            ...cloudVnKcpsDetailCopy.cloudVnConnectCommon,
          },
          cloudVnConnectAct: cloudVnKcpsDetailCopy.cloudVnConnectAct,
          cloudVnConnectSby: cloudVnKcpsDetailCopy.cloudVnConnectSby,
          cloudVnKcpsKeyId: cloudVnKcpsDetailCopy.cloudVnKcpsKeyId,
        };
        return form;
      } else {
        // 追加
        const form: CloudVnKcpsPostV2 = {
          cloudVnConnectCommon: {
            bandwidthType: "PF",
            routeAggregation: "OFF",
            routeAggregationAddressList: [""],
            location: "KEST1",
            maximumPrefix: 100,
            publicRelation: true,
            publicRelationSplitRouteList: null,
            publicRelationConnectedExceptList: null,
            publicRelationNextHopList: null,
          } as unknown as CloudVnKcpsPostV2["cloudVnConnectCommon"],
          cloudVnConnectAct: {} as CloudVnKcpsPostV2["cloudVnConnectAct"],
          cloudVnConnectSby: {} as CloudVnKcpsPostV2["cloudVnConnectSby"],
          cloudVnKcpsKeyId: this.cloudVnKcpsKeyId!,
        };
        return form;
      }
    })();

    return {
      form: form,
      isLoaded: false,
      vpnVnCodeList: [] as VpnVnCode[],
      selectedVpnVn: null as null | CloudVpnVnCode,
      bandwidthOptions: [
        { text: "10Mbps", value: { value: 10, unit: "MBPS" } },
        { text: "20Mbps", value: { value: 20, unit: "MBPS" } },
        { text: "30Mbps", value: { value: 30, unit: "MBPS" } },
        { text: "40Mbps", value: { value: 40, unit: "MBPS" } },
        { text: "50Mbps", value: { value: 50, unit: "MBPS" } },
        { text: "60Mbps", value: { value: 60, unit: "MBPS" } },
        { text: "70Mbps", value: { value: 70, unit: "MBPS" } },
        { text: "80Mbps", value: { value: 80, unit: "MBPS" } },
        { text: "90Mbps", value: { value: 90, unit: "MBPS" } },
        { text: "100Mbps", value: { value: 100, unit: "MBPS" } },
        { text: "200Mbps", value: { value: 200, unit: "MBPS" } },
        { text: "300Mbps", value: { value: 300, unit: "MBPS" } },
        { text: "400Mbps", value: { value: 400, unit: "MBPS" } },
        { text: "500Mbps", value: { value: 500, unit: "MBPS" } },
        { text: "600Mbps", value: { value: 600, unit: "MBPS" } },
        { text: "700Mbps", value: { value: 700, unit: "MBPS" } },
        { text: "800Mbps", value: { value: 800, unit: "MBPS" } },
        { text: "900Mbps", value: { value: 900, unit: "MBPS" } },
        { text: "1Gbps", value: { value: 1, unit: "GBPS" } },
        { text: "2Gbps", value: { value: 2, unit: "GBPS" } },
        { text: "3Gbps", value: { value: 3, unit: "GBPS" } },
        { text: "4Gbps", value: { value: 4, unit: "GBPS" } },
        { text: "5Gbps", value: { value: 5, unit: "GBPS" } },
        { text: "6Gbps", value: { value: 6, unit: "GBPS" } },
        { text: "7Gbps", value: { value: 7, unit: "GBPS" } },
        { text: "8Gbps", value: { value: 8, unit: "GBPS" } },
        { text: "9Gbps", value: { value: 9, unit: "GBPS" } },
        { text: "10Gbps", value: { value: 10, unit: "GBPS" } },
      ] as { text: string; value: BandWidth }[],
      routeOptions: [
        { value: "ON", text: "ON" },
        { value: "OFF", text: "OFF" },
        { value: "CUSTOM", text: "CUSTOM" },
      ],
      locationOptions: [
        { value: "KEST1", text: "jp-kest-1(東日本)" },
        { value: "KEST2", text: "jp-kest-2(東日本)" },
        { value: "KWST1", text: "jp-kwst-1(西日本)" },
      ],
      /** Maximum Prefix上限値(変更の場合用) */
      maximumPrefixLimit: null as UpperLimitEntity | null,
      /** 1G超VNコネクト */
      vnConnects1G: null as UpperLimitEntity | undefined | null,
      // 設定可能帯域
      editRemainingBandwidth: 0 as number,
    };
  },
  computed: {
    currentLength(): number {
      return this.form.cloudVnConnectCommon!.routeAggregationAddressList
        ? this.form.cloudVnConnectCommon!.routeAggregationAddressList.length
        : 0;
    },
    /** true: 新規, false: 変更 */
    isAdd(): boolean {
      return !this.cloudVnKcpsDetail;
    },
    vpnVnCodeSelectList(): {
      value: string;
      text: string;
    }[] {
      return this.vpnVnCodeList.map((v) => {
        if (v.vnName) {
          return {
            value: v.vpnVnCode,
            text: v.vnName + ":" + v.vpnVnCode + "(L3)",
          };
        } else {
          return { value: v.vpnVnCode, text: v.vpnVnCode };
        }
      });
    },
    /** 品目の選択肢 */
    bandwidthSelectList(): { text: string; value: BandWidth }[] {
      // クラウド帯域値 ※無料枠の場合には固定で1Gbps
      const limit1 = this.billingFreeFlg
        ? 1000000000
        : this.$filter.bandwidthToBps(this.cloudLineMaxBandwidth);
      // 1G超VNコネクト上限値を決定 (無料枠の場合は1Gbpsに制限)
      const limit2 = this.$filter.bandwidthToBps({
        value: this.billingFreeFlg ? 1 : this.vnConnects1G!.upperLimit,
        unit: "GBPS",
      });
      return this.bandwidthOptions.filter((v) => {
        const bps = this.$filter.bandwidthToBps(v.value)!;
        if (this.billingFreeFlg) {
          return bps <= limit1! && bps <= limit2!;
        }
        return (
          bps <= limit1! && bps <= limit2! && bps <= this.editRemainingBandwidth
        );
      });
    },
    /** Maximum Prefixの選択肢 */
    maximumPrefixSelectList(): { text: string; value: number }[] {
      if (this.isAdd) {
        return [{ value: 100, text: "100" }];
      } else {
        return [
          { value: 100, text: "100" },
          { value: 200, text: "200" },
          { value: 300, text: "300" },
          { value: 400, text: "400" },
          { value: 500, text: "500" },
          { value: 1000, text: "1000" },
          { value: 1500, text: "1500" },
          { value: 2000, text: "2000" },
        ].filter((v) => v.value <= this.maximumPrefixLimit!.upperLimit);
      }
    },

    vpnVnName(): string {
      if (
        this.cloudVnKcpsDetail!.cloudVnConnectCommon.vpnVnCode.startsWith("D")
      ) {
        return (
          this.cloudVnKcpsDetail!.cloudVnConnectCommon.vnName +
          ":" +
          this.cloudVnKcpsDetail!.cloudVnConnectCommon.vpnVnCode +
          "(L3)"
        );
      } else {
        return this.cloudVnKcpsDetail!.cloudVnConnectCommon.vpnVnCode;
      }
    },
    /** 経路集約アドレスの重複チェック用リスト作成 */
    routingAddressList() {
      return (index: number) => {
        return this.form.cloudVnConnectCommon!.routeAggregationAddressList
          ? this.form.cloudVnConnectCommon!.routeAggregationAddressList.filter(
              (_, num) => num !== index
            )
          : [];
      };
    },
    /** BGP 広報ルート(ルート分割)のアイテム数 */
    publicRelationSplitRouteItems(): string[] {
      return this.form.cloudVnConnectCommon!.publicRelationSplitRouteList ?? [];
    },
    /** BGP 広報ルート(Connected以外)のアイテム数 */
    publicRelationConnectedExceptItems(): string[] {
      return (
        this.form.cloudVnConnectCommon!.publicRelationConnectedExceptList ?? []
      );
    },
    /** ルート分割の重複チェック用リスト */
    splitRouteListExcluding() {
      return (index: number) => {
        return this.form.cloudVnConnectCommon!.publicRelationSplitRouteList
          ? this.form.cloudVnConnectCommon!.publicRelationSplitRouteList.filter(
              (_, num) => num !== index
            )
          : [];
      };
    },
    /** Connected以外の重複チェック用リスト */
    connectedExceptListExcluding() {
      return (index: number) => {
        return this.form.cloudVnConnectCommon!.publicRelationConnectedExceptList
          ? this.form.cloudVnConnectCommon!.publicRelationConnectedExceptList.filter(
              (_, num) => num !== index
            )
          : [];
      };
    },
    locationPrefix(): string {
      const locationPrefixMap: Record<string, string> = {
        KEST1: "jp-kest-1",
        KEST2: "jp-kest-2",
        KWST1: "jp-kwst-1",
      };
      return (
        locationPrefixMap[
          (this.form as CloudVnKcpsPostV2).cloudVnConnectCommon!.location
        ] ?? ""
      );
    },
  },
  watch: {
    /** 経路集約がCUSTOMに変更されて初期値が存在しない場合は初期化 */
    "form.cloudVnConnectCommon.routeAggregation"(newValue: RouteAggregation) {
      if (
        newValue === "CUSTOM" &&
        (!this.form.cloudVnConnectCommon!.routeAggregationAddressList ||
          this.form.cloudVnConnectCommon!.routeAggregationAddressList.length ===
            0)
      ) {
        this.form.cloudVnConnectCommon!.routeAggregationAddressList = [""];
      }
    },
  },
  async mounted() {
    this.maxBandwidth();
    await this.load();

    this.isLoaded = true;
  },
  methods: {
    async load() {
      // 1G超VNコネクトの値を取得（品目の上限値制御用）
      this.vnConnects1G = (
        await this.$api.upperLimit.getUpperLimitLine({
          upperLimitLineManageUnit: "MULTI_CLOUD",
          cloudLineSeq: this.cloudLineSeq,
        })
      ).cloudLine!.upperLimitList!.find(
        (v: { upperLimitItemName: string }) =>
          v.upperLimitItemName === "1G超VNコネクト"
      )!;

      if (this.isAdd) {
        this.vpnVnCodeList = (await this.$api.information.getVpnVnCodeList())
          .filter(
            (v: { vnType: string | null }) =>
              v.vnType === "L3" || v.vnType === null
          )
          .sortBy(["vpnVnCode", "asc"]);
      } else {
        // maximumPrefixの上限値を取得
        this.maximumPrefixLimit = (
          await this.$api.upperLimit.getUpperLimitLine({
            upperLimitLineManageUnit: "MULTI_CLOUD",
            cloudLineSeq: this.cloudLineSeq,
            wnumber: this.cloudVnKcpsDetail!.cloudVnConnectAct.wnumber,
          })
        ).cloudLine!.upperLimitList!.find(
          (v: { upperLimitItemName: string }) =>
            v.upperLimitItemName === "BGP4の最大経路数"
        )!;
      }
    },

    maxBandwidth() {
      if (!this.isAdd) {
        this.editRemainingBandwidth =
          this.remainingBandwidth +
          this.$filter.bandwidthToBps(
            this.cloudVnKcpsDetail!.cloudVnConnectCommon.bandwidth
          )!;
      } else {
        this.editRemainingBandwidth = this.remainingBandwidth;
      }
      return this.editRemainingBandwidth;
    },

    /** 経路集約アドレス削除 */
    removeRouteAddress(index: number, remove: (idx: number) => void) {
      const list = this.form.cloudVnConnectCommon!.routeAggregationAddressList!;
      if (list.length > 1) {
        list.splice(index, 1);
        // ValidationにFieldを削除することを伝える
        remove(index);
      } else {
        this.form.cloudVnConnectCommon!.routeAggregationAddressList = [""];
      }
    },

    /** 経路集約アドレス追加 */
    addRouteAddress(push: (item: any) => void) {
      const addItem = "";
      this.form.cloudVnConnectCommon!.routeAggregationAddressList = [
        ...this.form.cloudVnConnectCommon!.routeAggregationAddressList!,
        addItem,
      ];
      // ValidationにFieldを追加することを伝える
      push(addItem);
    },

    /** BGP 広報ルート(ルート分割)追加 */
    addSplitRoute(push: (item: string) => void) {
      if (!this.form.cloudVnConnectCommon!.publicRelationSplitRouteList) {
        this.form.cloudVnConnectCommon!.publicRelationSplitRouteList = [];
      }
      if (
        this.form.cloudVnConnectCommon!.publicRelationSplitRouteList.length >=
        10
      ) {
        return;
      }
      const addItem = "";
      this.form.cloudVnConnectCommon!.publicRelationSplitRouteList = [
        ...this.form.cloudVnConnectCommon!.publicRelationSplitRouteList,
        addItem,
      ];
      // ValidationにFieldを追加することを伝える
      push(addItem);
    },
    /** BGP 広報ルート(ルート分割)削除 */
    removeSplitRoute(index: number, remove: (idx: number) => void) {
      if (
        this.form.cloudVnConnectCommon!.publicRelationSplitRouteList!.length ===
        1
      ) {
        this.form.cloudVnConnectCommon!.publicRelationSplitRouteList = null;
      } else {
        this.form.cloudVnConnectCommon!.publicRelationSplitRouteList!.splice(
          index,
          1
        );
      }
      // ValidationにFieldを削除することを伝える
      remove(index);
    },
    /** BGP 広報ルート(Connected以外)追加 */
    addConnectedExcept(push: (item: string) => void) {
      if (!this.form.cloudVnConnectCommon!.publicRelationConnectedExceptList) {
        this.form.cloudVnConnectCommon!.publicRelationConnectedExceptList = [];
      }
      if (!this.form.cloudVnConnectCommon!.publicRelationNextHopList) {
        this.form.cloudVnConnectCommon!.publicRelationNextHopList = [];
      }
      if (
        this.form.cloudVnConnectCommon!.publicRelationConnectedExceptList
          .length >= 100
      ) {
        return;
      }
      const addItem = "";
      this.form.cloudVnConnectCommon!.publicRelationConnectedExceptList = [
        ...this.form.cloudVnConnectCommon!.publicRelationConnectedExceptList,
        addItem,
      ];
      this.form.cloudVnConnectCommon!.publicRelationNextHopList = [
        ...this.form.cloudVnConnectCommon!.publicRelationNextHopList,
        addItem,
      ];
      // ValidationにFieldを追加することを伝える
      push(addItem);
    },
    /** BGP 広報ルート(Connected以外)削除 */
    removeConnectedExcept(index: number, remove: (idx: number) => void) {
      if (
        this.form.cloudVnConnectCommon!.publicRelationConnectedExceptList!
          .length === 1
      ) {
        this.form.cloudVnConnectCommon!.publicRelationConnectedExceptList =
          null;
        this.form.cloudVnConnectCommon!.publicRelationNextHopList = null;
      } else {
        this.form.cloudVnConnectCommon!.publicRelationConnectedExceptList!.splice(
          index,
          1
        );
        this.form.cloudVnConnectCommon!.publicRelationNextHopList!.splice(
          index,
          1
        );
      }
      // ValidationにFieldを削除することを伝える
      remove(index);
    },

    async submit() {
      const form = {
        ...this.form,
        cloudVnConnectCommon: {
          ...this.form.cloudVnConnectCommon,
          routeAggregationAddressList:
            this.form.cloudVnConnectCommon!.routeAggregation === "ON"
              ? []
              : this.form.cloudVnConnectCommon!.routeAggregation === "OFF"
                ? null
                : this.form.cloudVnConnectCommon!.routeAggregationAddressList,
          billingFree: this.billingFreeFlg,
        },
      } as CloudVnKcpsPostV2 | CloudVnKcpsPutV2;

      if (this.isAdd) {
        // 追加の場合
        (form as CloudVnKcpsPostV2).cloudVnConnectCommon!.vpnVnCode =
          this.selectedVpnVn!;
        const displayVnName = this.vpnVnCodeList.find(
          (v) =>
            v.vpnVnCode ===
            (form as CloudVnKcpsPostV2).cloudVnConnectCommon!.vpnVnCode
        )!.vnName;

        // 確認モーダルの表示
        await this.$modal.show(MultiCloudKcps3VnConnectionEditConfirm, {
          cloudVnKcpsDetail: {
            cloudVnConnectCommon: {
              ...form.cloudVnConnectCommon,
              vnName: displayVnName,
              routingType: "BGP4",
            },
            cloudVnConnectAct: {
              ...form.cloudVnConnectAct,
              localPreference: "HIGH_PRIORITY",
              med: "LOW_PRIORITY",
            },
            cloudVnConnectSby: {
              ...form.cloudVnConnectSby,
              localPreference: "LOW_PRIORITY",
              med: "HIGH_PRIORITY",
            },
          },
          displayType: "A",
          billingFreeFlg: this.billingFreeFlg,
        });
        await this.$api.cloudVnKcps.postVnConnectV2(
          this.cloudLineSeq,
          form as CloudVnKcpsPostV2
        );
        (this.$refs.modal as typeof VueFinalModal & { ok: () => void }).ok();
      } else {
        // 変更の場合
        // 確認モーダルの表示
        await this.$modal.show(MultiCloudKcps3VnConnectionEditConfirm, {
          cloudVnKcpsDetail: form,
          displayType: "M",
          billingFreeFlg: this.billingFreeFlg,
        });
        // 変更APIの呼び出し
        await this.$api.cloudVnKcps.putVnConnectV2(
          this.cloudLineSeq,
          this.cloudVnKcpsDetail!.cloudVnConnectAct.wnumber,
          form as CloudVnKcpsPutV2
        );
        (this.$refs.modal as typeof VueFinalModal & { ok: () => void }).ok();
      }
    },
  },
});
</script>

<style lang="scss" scoped>
.address-title :deep(.badge-label) {
  font-size: 0.75rem !important;
}
</style>
